(ns frontend.view.components.form.components.form-company-name
  (:require-macros [frontend.macros :refer [without-default-action]])
  (:require [frontend.view.components.form.components.form-label :as form-label]
            [frontend.routing :as routing]
            [frontend.bootstrap.components :as rbs]
            [frontend.utils :as fu]))

(defn view
  [{:keys [size value field wrapper control-id] :as view-args}]
  (let [{:keys [company-id]} field]
    [:div
     {:class-name "px-4"}
     [rbs/Form
      {:class-name "form-company-name"}
      [rbs/FormGroup
       {:control-id control-id
        :size    size
        :class-name (fu/cs wrapper "form__text form__tab")}
       [form-label/view view-args]
       [:div.form__tab__nav
        [rbs/Nav {:variant "pills"
                  :class-name "form__background isCompany"}
         [rbs/NavItem
          {:href (if-not company-id "#" (routing/path-for :entity.type/company :id company-id))
           :on-click (without-default-action
                       (routing/open-entity company-id))}
          [:i
           {:class-name "fal fa-building form__background__icon"
            :aria-hidden true}]
          (str " " value)]]]]]]))
